import React from "react";

// Default decorative graphic used when the editor uploads no custom image.
// Inline SVG scales in proportion at any width with no distortion.
const SovendusDefaultGraphic: React.FC = (): React.JSX.Element => (
  <svg
    viewBox="0 0 240 200"
    role="img"
    aria-label="Geschenk"
    style={{
      display: "block",
      width: "100%",
      height: "auto",
      maxWidth: 240,
      margin: "0 auto",
    }}
  >
    <g fill="none" stroke="#1a1a1a" strokeWidth="6" strokeLinejoin="round">
      <rect x="70" y="90" width="100" height="80" fill="#ffffff" />
      <rect x="60" y="70" width="120" height="24" fill="#ffffff" />
      <line
        x1="120"
        y1="70"
        x2="120"
        y2="170"
        stroke="#caa14a"
        strokeWidth="10"
      />
      <path
        d="M120 70 C104 44 78 44 86 64 C92 76 112 70 120 70Z"
        fill="#caa14a"
      />
      <path
        d="M120 70 C136 44 162 44 154 64 C148 76 128 70 120 70Z"
        fill="#caa14a"
      />
    </g>
    <g fill="#caa14a">
      <circle cx="30" cy="30" r="5" />
      <circle cx="210" cy="40" r="5" />
      <circle cx="200" cy="120" r="4" />
      <circle cx="34" cy="120" r="4" />
    </g>
  </svg>
);

export default SovendusDefaultGraphic;
